export default __webpack_public_path__ + "static/Voyance-6da8cc382a449b257c8b7739501a93d3.png";